module.exports = __webpack_public_path__ + "static/media/typingHome.b405c151.png";